import { Stack } from '@chakra-ui/react'
import { useState } from 'react'

import type { PostDetails, PostEventDetails } from '@/components/Community/Post/types'

import DeletePostEventModal from './internal/DeletePostEventModal'
import PostEvent from './internal/PostEvent'

export default function PostEventList({
  post,
  postEvents,
  optimisticPostEvents,
  onPostEventDelete,
}: {
  post: PostDetails
  postEvents: PostEventDetails[]
  optimisticPostEvents: PostEventDetails[]
  onPostEventDelete: (clientId: string) => void
}): JSX.Element {
  const [postEventToDelete, setPostEventToDelete] = useState<PostEventDetails | null>(null)

  return (
    <>
      {postEventToDelete == null ? null : (
        <DeletePostEventModal
          open={postEventToDelete != null}
          onClose={() => setPostEventToDelete(null)}
          onDelete={onPostEventDelete}
          postEvent={postEventToDelete}
        />
      )}
      <Stack direction="column" spacing="0px">
        {postEvents.map(postEvent => (
          <PostEvent
            key={postEvent.clientId}
            post={post}
            postEvent={postEvent}
            onDelete={(p: PostEventDetails) => setPostEventToDelete(p)}
          />
        ))}
        {optimisticPostEvents
          .filter(
            optimisticPostEvent =>
              !postEvents.some(postEvent => postEvent.clientId === optimisticPostEvent.clientId)
          )
          .map(postEvent => (
            <PostEvent
              key={`${postEvent.clientId}-optimistic`}
              post={post}
              postEvent={postEvent}
              onDelete={(p: PostEventDetails) => setPostEventToDelete(p)}
              isOptimistic
            />
          ))}
      </Stack>
    </>
  )
}
